import { Injectable } from '@angular/core';
import { DataListModel } from '../../models/data-list-model';
import { Observable } from 'rxjs';
import { Product } from '../../dto/product';
import {HttpParams, HttpClient, HttpResponse} from '@angular/common/http';

import {CustomerRisk} from '../../dto/customer-risk';
import {toServerDateString} from '../../providers/app-date-adapter';
import {RiskLevelStatsModel} from '../../models/risk-level-stats-model';

@Injectable({
  providedIn: 'root'
})
export class RiskOverviewService {
  readonly apiPath = 'risk-level-overview/';
  public id: number;
  constructor(
    private http: HttpClient,
  ) { }


  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[]
  ): Observable<DataListModel<CustomerRisk>> {
    let params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection );

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    return this.http.get( this.apiPath, { params } ) as Observable<DataListModel<CustomerRisk>>;
  }

  get( id: number ): Observable<CustomerRisk> {
    return this.http.get( this.apiPath + id ) as Observable<CustomerRisk>;
  }

  getStats(companyFilter: string[]): Observable<RiskLevelStatsModel> {

    const params = new HttpParams()
      .set( 'companyFilter', companyFilter.join(',') );

    return this.http.get( this.apiPath + 'stats', {params} ) as Observable<RiskLevelStatsModel>;
  }

  add( item: CustomerRisk ): Observable<CustomerRisk> {
    throw new Error( 'Method not implemented.' );
  }
  update( item: CustomerRisk ) {
    return this.http.put( this.apiPath, item ) as Observable<CustomerRisk>;
  }

  delete( id: any ) {
    return this.deleteMany( [ id ] );
  }

  restore( id: any ) {
    return this.restoreMany( [ id ] );
  }

  deleteMany( idList: any[] ) {
    let httpParams = new HttpParams();

    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );

    return this.http.delete( this.apiPath, { params: httpParams } );
  }

  restoreMany( idList: any[] ) {
    let httpParams = new HttpParams();
    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );
    return this.http.patch( this.apiPath, null, { params: httpParams } );
  }


  getReportCsv( pageIndex: number,
                pageSize: number,
                sortField: string,
                sortDirection: string,
                filterString: string,
                dateFilterCols: string[],
                startFilterDate: Date,
                endFilterDate: Date,
                someAdditionalData: string,
                additionalFilterData: string[],
                enumFilter: { key: string; value: string },
                companiesFilter: string[],
                additionalField1: string,
                additionalField2: string,
                additionalValue1: string,
                additionalValue2: string ): Observable<HttpResponse<Blob>> {

    console.log(additionalValue2);

    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString == null ? '' : filterString)
      .set('sortField', sortField == null ? '' : sortField)
      .set( 'sortDirection', sortDirection == null ? '' : sortDirection )
      .set( 'someAdditionalData', someAdditionalData == null ? '' : someAdditionalData )
      .set('startFilterDate', startFilterDate == null ? '' : toServerDateString(startFilterDate))

      .set('additionalField1', additionalField1 == null ? '' : additionalField1)
      .set('additionalField2', additionalField2 == null ? '' : additionalField2)
      .set('additionalValue1', additionalValue1 == null ? '' : additionalValue1)
      .set('additionalValue2', additionalValue2 == null ? '' : additionalValue2)

      .set('endFilterDate', endFilterDate == null ? '' : toServerDateString(endFilterDate));

    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return this.http.get( this.apiPath + 'download', { params, responseType: 'blob', observe: 'response' } );
  }

  getCardActivitiesReportCsv( pageIndex: number,
                pageSize: number,
                sortField: string,
                sortDirection: string,
                filterString: string,
                dateFilterCols: string[],
                startFilterDate: Date,
                endFilterDate: Date,
                someAdditionalData: string,
                additionalFilterData: string[],
                enumFilter: { key: string; value: string },
                companiesFilter: string[],
                additionalField1: string,
                additionalField2: string,
                additionalValue1: string,
                additionalValue2: string ): Observable<HttpResponse<Blob>> {

    console.log(additionalValue2);

    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString == null ? '' : filterString)
      .set('sortField', sortField == null ? '' : sortField)
      .set( 'sortDirection', sortDirection == null ? '' : sortDirection )
      .set( 'someAdditionalData', someAdditionalData == null ? '' : someAdditionalData )
      .set('startFilterDate', startFilterDate == null ? '' : toServerDateString(startFilterDate))

      .set('additionalField1', additionalField1 == null ? '' : additionalField1)
      .set('additionalField2', additionalField2 == null ? '' : additionalField2)
      .set('additionalValue1', additionalValue1 == null ? '' : additionalValue1)
      .set('additionalValue2', additionalValue2 == null ? '' : additionalValue2)

      .set('endFilterDate', endFilterDate == null ? '' : toServerDateString(endFilterDate));

    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return this.http.get( this.apiPath + 'download/card-activity-report', { params, responseType: 'blob', observe: 'response' } );
  }

  getNonAllGoodCardsReportCsv( pageIndex: number,
                              pageSize: number,
                              sortField: string,
                              sortDirection: string,
                              filterString: string,
                              dateFilterCols: string[],
                              startFilterDate: Date,
                              endFilterDate: Date,
                              someAdditionalData: string,
                              additionalFilterData: string[],
                              enumFilter: { key: string; value: string },
                              companiesFilter: string[],
                              additionalField1: string,
                              additionalField2: string,
                              additionalValue1: string,
                              additionalValue2: string ): Observable<HttpResponse<Blob>> {

    console.log(additionalValue2);

    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString == null ? '' : filterString)
      .set('sortField', sortField == null ? '' : sortField)
      .set( 'sortDirection', sortDirection == null ? '' : sortDirection )
      .set( 'someAdditionalData', someAdditionalData == null ? '' : someAdditionalData )
      .set('startFilterDate', startFilterDate == null ? '' : toServerDateString(startFilterDate))

      .set('additionalField1', additionalField1 == null ? '' : additionalField1)
      .set('additionalField2', additionalField2 == null ? '' : additionalField2)
      .set('additionalValue1', additionalValue1 == null ? '' : additionalValue1)
      .set('additionalValue2', additionalValue2 == null ? '' : additionalValue2)

      .set('endFilterDate', endFilterDate == null ? '' : toServerDateString(endFilterDate));

    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return this.http.get( this.apiPath + 'download/non-all-good-cards-report', { params, responseType: 'blob', observe: 'response' } );
  }



}
